import type { IntlShape } from 'react-intl';

import type { Location } from './OrderFormValidation.ts';

type LocationSuggestionType = 'header' | 'here' | 'poi';

const BaseLocationSuggestionHeader: Omit<LocationSuggestion, 'key'> = {
    type: 'header',
    addressPreview: '',
    header: true,
    disabled: true,
    latitude: 0,
    longitude: 0,
};

export const getLocationSuggestionPoiHeader = (intl: IntlShape): LocationSuggestion => ({
    ...BaseLocationSuggestionHeader,
    key: 'header-pois',
    label: intl.formatMessage({
        id: 'intl-msg:ordercom-cloud-frontend.orders.address-autocomplete.pois',
    }),
});

export const getLocationSuggestionAddressesHeader = (intl: IntlShape): LocationSuggestion => ({
    ...BaseLocationSuggestionHeader,
    key: 'header-addresses',
    label: intl.formatMessage({
        id: 'intl-msg:ordercom-cloud-frontend.orders.address-autocomplete.addresses',
    }),
});

export const poiDisplayText = (suggestion: LocationSuggestion) => {
    if (!suggestion.name) {
        return suggestion.addressPreview;
    }

    return suggestion.addressPreview.toLowerCase().startsWith(`${suggestion.name.toLowerCase()},`)
        ? suggestion.addressPreview
        : `${suggestion.name}, ${suggestion.addressPreview}`;
};

export type LocationSuggestion = {
    key: string;
    type: LocationSuggestionType;
    label?: string;
    header?: boolean;
    disabled?: boolean;
    addressPreview: string;
    name?: string;
    category?: string;
    city?: string;
    country?: string;
    street?: string;
    postcode?: string;
    latitude: number;
    longitude: number;
};

export const toAddress = (suggestion: LocationSuggestion): Location => ({
    city: suggestion.city ?? '',
    country: suggestion.country ?? '',
    street: suggestion.street ?? '',
    zipCode: suggestion.postcode ?? '',
    latitude: suggestion.latitude,
    longitude: suggestion.longitude,
});
